module.exports = __webpack_public_path__ + "logo-alt.e581636eb495bf4e0f2af9a4ddb8d906.png";